import { LoginStatus } from "./auth.state";

export class CheckMobileNumber{
    static readonly type = '[Auth] Set Mobile Number';
    constructor(public payload:{mobileNumber:string,countryCode:string}){}
}

export class Login{
    static readonly type = '[Auth] Login';
    constructor(public payload:{mobileNumber:string, otp:string} ){}
}

export class Register{
    static readonly type = '[Auth] Register';
    constructor(public payload:{mobileNumber:string, countryCode:string, name:string, email:string} ){}
}

export class Logout{
    static readonly type = '[Auth] Logout';
}

export class SetLoginStatus{
    static readonly type = '[Auth] Set Login Status';
    constructor(public payload:LoginStatus){}
}
